module.exports = __webpack_public_path__ + "static/media/kamel-cherif.c37cd1d2.jpg";